<template>
  <van-popup
    v-model="show"
    round
    position="bottom"
    :close-on-click-overlay="canClose"
    duration="0.05"
    :style="{ height: active == 1 ? '80%' : 'auto' }"
    @close="close"
  >
    <div class="container">
      <div class="info__header">
        <div v-if="onlyGrade">选择年级和学期</div>
        <div v-else>填写信息 ({{ active + 1 }}/2)</div>
      </div>
      <div class="info__bottom">
        <van-tabs
          v-model="active"
          line-width="14px"
          title-active-color="#000000"
          title-inactive-color="#999999"
          class="van__tabs"
          :border="false"
        >
          <!-- 设置年级 start -->
          <van-tab title="设置年级" class="van__tab">
            <div class="title">
              <span class="text__bg">
                <span class="text">年级</span>
              </span>
              <span v-if="!onlyGrade" class="emphasize">（*请选择开学后的对应年级）</span>
            </div>
            <Grid :cols="3" row-margin="0.27rem" col-margin="0.4rem">
              <GridItem
                v-for="({ chName, value }, index) in dicSettingGrade"
                :key="index"
                class="grid__item"
                margin-bottom="13"
              >
                <div
                  class="option__item"
                  :class="{ 'option__item--active': gradeSelected === Number(value) }"
                  @click="gradeSelected = Number(value)"
                >
                  <span class="option__text">{{ chName }}</span>
                </div>
              </GridItem>
            </Grid>
            <div class="title">
              <span class="text__bg">
                <span class="text">学期</span>
              </span>
            </div>
            <Grid :cols="3" row-margin="0.27rem" col-margin="0.4rem">
              <GridItem v-for="(item, index) in terms" :key="index" class="grid__item">
                <div
                  class="option__item"
                  :class="{ 'option__item--active': index === termSelected - 1 }"
                  @click="termSelected = index + 1"
                >
                  <span class="option__text">{{ item }}</span>
                </div>
              </GridItem>
            </Grid>

            <div class="button__box">
              <div v-if="step1NextDisabledShow" class="tipsText">
                <img
                  width="100%"
                  height="100%"
                  src="https://img.yzcdn.cn/upload_files/2020/11/16/Fktqnv_q7NS_TC6JEV6rBJ36RY3q.png"
                />请选择你目前所在年级和学期后点击下一步
              </div>
              <van-button
                round
                hairline
                type="info"
                class="button button__next"
                :class="!step1NextDisabled && 'active'"
                :loading="step1buttonLoading"
                @click="handleNextStep1"
              >
                {{ onlyGrade ? '确定' : '下一步' }}
              </van-button>
            </div>
          </van-tab>
          <!-- 设置年级 end -->
          <!-- 设置版本 start -->
          <van-tab title="设置版本" class="vant__tab tab__1">
            <div class="collapse__box">
              <van-collapse v-model="versionCollapseActiveNames" :border="false">
                <van-collapse-item
                  v-for="(courses, index) in [coursesMain, coursesOther].filter(
                    (arr) => arr.length > 0
                  )"
                  :key="index"
                  :border="false"
                  :name="index"
                >
                  <template #title>
                    <div
                      class="versions__title"
                      :class="{
                        active: versionCollapseActiveNames.includes(index),
                        fuke: index > 0
                      }"
                    >
                      <div>{{ ['主科', '副科'][index] }}</div>
                      <van-icon
                        v-if="versionCollapseActiveNames.includes(index)"
                        class="icon"
                        name="arrow-down"
                        color="#FF6F57"
                        size="18"
                      />
                      <van-icon v-else class="icon" name="arrow-up" color="#FF6F57" size="18" />
                    </div>
                  </template>
                  <template #right-icon>
                    <span></span>
                  </template>
                  <div v-for="course in courses" :key="course.course">
                    <div class="title">
                      <span class="text__bg">
                        <span class="text">{{ course.name }}</span>
                      </span>
                    </div>
                    <Grid :cols="3" row-margin="0.27rem" col-margin="0.4rem">
                      <GridItem
                        v-for="version in course.versions"
                        :key="version.version"
                        class="grid__item"
                        margin-bottom="12"
                      >
                        <div
                          class="option__item"
                          :class="{
                            'option__item--active': versionsUserSelected.find(
                              ({ courseId, editionId }) =>
                                courseId === course.course && version.version === editionId
                            )
                          }"
                          @click="versionClicked(course, version)"
                        >
                          <span class="option__text">{{ version.name }}</span>
                        </div>
                      </GridItem>
                    </Grid>
                  </div>
                </van-collapse-item>
              </van-collapse>
            </div>
            <div class="button__box">
              <van-button hairline type="info" class="button button__pre" @click="active = 0">
                上一步
              </van-button>

              <van-button
                round
                hairline
                type="info"
                class="button button_finish_unset"
                :loading="step2buttonLoading"
                :disabled="step3buttonLoading"
                @click="() => finish(true)"
              >
                暂不设置版本
              </van-button>
              <van-button
                round
                hairline
                type="info"
                class="button button__finish"
                :disabled="!canFinish || step2buttonLoading"
                :loading="step3buttonLoading"
                @click="() => finish()"
              >
                完成
              </van-button>
            </div>
          </van-tab>
          <!-- 设置版本 end -->
        </van-tabs>
      </div>
    </div>
  </van-popup>
</template>

<script>
import { mapGetters } from 'vuex'
import Grid from '@/components/Grid'
import { register } from '@/plugin/popup'

const terms = ['上学期', '下学期']

export default {
  components: {
    Grid,
    GridItem: Grid.item
  },
  data() {
    return {
      show: false,
      active: 0, // 0 选择班级 1选择教材版本
      terms, // 年级选项
      step1NextDisabledShow: false, // 设置年级学期不可用提醒
      canClose: true,
      coursesMain: [],
      coursesOther: [],
      gradeSelected: -1,
      termSelected: -1,
      versionsUserSelected: [],
      numberOfAllCourse: 9999,
      versionCollapseActiveNames: [0, 1],
      step1buttonLoading: false,
      step2buttonLoading: false,
      step3buttonLoading: false,
      onlyGrade: false // 只选择年级, 答案核对页面不让选择版本
    }
  },
  computed: {
    ...mapGetters([
      'userGrade',
      'userTerm',
      'appid',
      'openid',
      'userWbVersion',
      'dicSettingGrade',
      'dicSettingCourses',
      'userSettingBookVersion'
    ]),
    // 选择年级的下一步，是否禁止
    step1NextDisabled() {
      return this.termSelected === -1 || this.gradeSelected === -1
    },
    // 是否所有科目都选择了
    canFinish() {
      return this.numberOfAllCourse === this.versionsUserSelected.length
      // const numberVerMainCour =
    }
  },
  async mounted() {
    register({
      name: 'PopupVersionSetting',
      open: async ({ afterClose, canClose, onlyGrade }) => {
        // await this.getOptions()
        this.onlyGrade = onlyGrade || false
        this.userGradeData2Index()
        this.afterClose = afterClose
        this.canClose = Boolean(canClose)
        this.active = 0
        this.show = true
      },
      close: () => {
        this.close()
      }
    })
  },
  methods: {
    close() {
      this.show = false
      if (this.afterClose) {
        setTimeout(() => {
          this.afterClose()
        }, 2000)
      }
    },
    // 根据store中用户选择过的年级,版本, 初始化data中的索引
    userGradeData2Index() {
      this.gradeSelected = Number(this.userGrade) || -1
      this.termSelected = Number(this.userTerm) || -1
      this.versionsUserSelected = JSON.parse(JSON.stringify(this.userSettingBookVersion || []))
    },
    // 拉取版本的列表后设置data中的索引
    async pullVersiongListByGradeThenSetIndex() {
      return this.$nextTick(() => {
        // console.log('dicc', this.dicSettingCourses)
        this.coursesMain = this.dicSettingCourses.filter(({ course }) => course <= 3)
        this.coursesOther = this.dicSettingCourses.filter(({ course }) => course > 3)
        this.numberOfAllCourse = this.dicSettingCourses.length
      })

      // 如果用户当前选择了的版本不存在与当前的版本列表中, 进行清除
      // this.versionsUserSelected = this.versionsUserSelected.filter(({ courseId, editionId }) => {
      //   const course = courses.find(({ course }) => course === courseId)
      //   if (!course) return false
      //   const version = course.versions.find(({ version }) => version === editionId)
      //   return version
      // })
    },
    versionClear(course) {
      if (course) {
        this.versionsUserSelected = this.versionsUserSelected.filter(
          ({ courseId }) => courseId !== course
        )
      } else {
        this.versionsUserSelected = []
      }
    },
    versionClicked(course, version) {
      const found = this.versionsUserSelected.find(
        ({ courseId, editionId }) => courseId === course.course && version.version === editionId
      )
      this.versionClear(course.course)
      if (!found) {
        this.versionsUserSelected.push({
          courseId: course.course,
          editionId: version.version,
          courseName: course.name,
          editionName: version.name
        })
      }
      // console.log(course, version, found)
    },
    // 设置年级 点击下一步
    handleNextStep1() {
      this.step1buttonLoading = true
      if (this.step1NextDisabled) {
        this.step1NextDisabledShow = true
        return setTimeout(() => {
          // toast.clear()
          this.step1buttonLoading = false
          this.step1NextDisabledShow = false
        }, 1500)
      }
      this.step1NextDisabledShow = false
      // 有没有改变年级
      const gradeModified = this.gradeSelected !== this.userGrade
      const termModified = this.termSelected !== this.userTerm
      if (gradeModified) {
        return this.$store
          .dispatch('user/modifyClassGrade', {
            grade: this.gradeSelected,
            term: this.termSelected,
            wbVersion: this.userWbVersion,
            clearVersion: 1
          })
          .then(() => {
            this.versionClear()
          })
          .then(() => {
            return this.pullVersiongListByGradeThenSetIndex()
          })
          .then(() => {
            this.step1buttonLoading = false
            if (this.onlyGrade) {
              this.canClose = true
              this.show = false
            } else {
              this.active = 1
            }
          })
      } else {
        let dispatchResult = Promise.resolve()
        // 如果修改了学期,则请求更新学期, 学期不影响版本
        if (termModified) {
          dispatchResult = this.$store.dispatch('user/modifyClassGrade', {
            grade: this.gradeSelected,
            term: this.termSelected,
            wbVersion: this.userWbVersion
          })
        }
        // 用户设置版本且没有变更年级时, 展开副科
        if (this.userSettingBookVersion.length > 0) {
          this.versionCollapseActiveNames = [0, 1]
        }
        return dispatchResult.then(() =>
          this.pullVersiongListByGradeThenSetIndex().then(() => {
            this.step1buttonLoading = false
            // toast.clear()
            if (this.onlyGrade) {
              this.canClose = true
              this.show = false
            } else {
              this.active = 1
            }
          })
        )
      }
    },
    // 提交数据 noon为ture时所有版本设置为空
    async finish(noon = false) {
      if (noon) {
        this.step2buttonLoading = true
        this.versionClear()
      } else {
        this.step3buttonLoading = true
      }
      try {
        // 按dicSettingCourses排序
        const sortIndexes = this.versionsUserSelected.map((item) => {
          return this.dicSettingCourses.findIndex((i) => item.courseId === i.course)
        })
        const sortedVersionsUserSelected = []
        sortIndexes.forEach(
          (idxInDic, idxInSelected) =>
            (sortedVersionsUserSelected[idxInDic] = this.versionsUserSelected[idxInSelected])
        )
        await this.$store.dispatch('user/modifySettingVersion', sortedVersionsUserSelected)
        this.canClose = true
        this.show = false
      } catch (e) {
        console.log(e)
        this.$toast.fail('设置失败')
      } finally {
        if (noon) {
          this.step2buttonLoading = false
          this.versionClear()
        } else {
          this.step3buttonLoading = false
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.van__tabs {
  transition: height 2s linear;
  height: 100%;

  ::v-deep .van-tabs__wrap {
    margin-top: 0.8rem;
    margin-bottom: 0.746rem;
    height: 0.72rem;
    display: none;
  }

  ::v-deep .van-cell--clickable:active {
    background: #fff;
  }

  ::v-deep .van-cell::after {
    border: none;
  }

  ::v-deep .van-tabs__content {
    height: 100%;
  }

  ::v-deep .van-collapse-item__title {
    padding: 0;
  }

  ::v-deep .van-collapse-item__content {
    padding: 0;
  }

  ::v-deep .van-tabs__line {
    height: 2px;
    background: #ff2638;
    border-radius: 2px;
  }

  ::v-deep .van-tab__text {
    font-size: 16px;
  }
}

.container {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .info__bottom {
    padding-left: 15px;
    padding-right: 15px;
    flex: 1;
    min-height: 408px;
    overflow: scroll;
  }

  .tab__1 {
    height: 100%;

    .collapse__box {
      padding-bottom: 150px;
    }
  }

  .info__header {
    flex-shrink: 0;
    height: 46px;
    width: 100%;
    background: linear-gradient(90deg, #ff715f 17.07%, #ff5e57 79.2%);
    border-radius: 15px 15px 0px 0px;
    font-family: PingFang SC;
    font-style: normal;
    font-weight: 500;
    font-size: 17px;
    line-height: 24px;
    /* identical to box height */

    color: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.title {
  margin: 27px 0 12px;
  font-family: PingFang SC;
  font-weight: bold;
  font-size: 17px;
  line-height: 24px;
  /* identical to box height */

  color: #333333;

  .emphasize {
    font-weight: normal;
    font-size: 13px;
    line-height: 18px;

    color: #999999;
  }

  .text__bg {
    position: relative;
    padding: 0 3px;

    .text {
      position: relative;
      z-index: 1;
    }
  }

  .text__bg::before {
    position: absolute;
    width: 100%;
    height: 7px;
    left: 0;
    bottom: 0;
    content: '';
    background: #fdeeeb;
    border-radius: 40px;
    z-index: 0;
  }
}

.grid__item {
  display: flex;
  justify-content: center;
}

.option__item {
  display: flex;
  justify-content: center;
  align-items: center;

  font-family: PingFang SC;

  width: 107px;
  height: 31px;
  left: 15px;
  top: 318px;

  background: #f7f8f9;
  border-radius: 90px;

  font-size: 13px;
  line-height: 18px;

  color: #333333;

  &.option__item--active {
    background: #fdeeeb;
    transition: all 0.1s linear;
    color: #ff6f57;
  }
}

.button__box {
  position: relative;
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  background: #fff;
  z-index: 2;
  padding: 0 15px;
  display: flex;
  justify-content: space-between;
  height: 72px;
  align-items: center;

  .button {
    font-family: PingFang SC;
    font-style: normal;
    font-weight: normal;
    font-size: 0.426rem;
    color: #ff2638;
    background: #fff;
    border-color: #ff2638;

    &:active {
      opacity: 0.7;
    }

    &.active {
      background: linear-gradient(90deg, #fd735d 0.16%, #ff423c 100.16%);
      color: #fff;
    }
  }

  .button__next {
    width: 100%;
  }

  .button__pre,
  .button__finish {
    width: 4.05rem;
    font-family: PingFang SC;
    font-style: normal;
    font-weight: normal;
  }

  .button__pre {
    width: 78px;
    border-color: #fff;

    font-size: 14px;
    line-height: 20px;
    color: #333333;
  }

  .button_finish_unset {
    padding: 0;
    width: 133px;
    border-color: #fe6956;
    color: #fe6956;
  }

  .button__finish {
    width: 114px;
    color: #ffffff;
    background: linear-gradient(90deg, #fd735d 0.16%, #ff423c 100.16%);
    font-size: 16px;
    line-height: 22px;
    color: #ffffff;
  }
}

.tipsText {
  position: absolute;
  left: 15px;
  top: -50px;
  margin: 0 auto;
  width: 345px;
  height: 40px;
  background: #000000;
  opacity: 0.7;
  border-radius: 25px;
  color: #ffffff;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 16px;
    height: 16px;
    margin-right: 11px;
  }
}

.tipsText1 {
  position: absolute;
  left: 15px;
  top: -62px;
  margin: 0 auto;
  width: 345px;
  height: 52px;
  background: #000000;
  opacity: 0.7;
  border-radius: 25px;
  color: #ffffff;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 14px 33px;

  img {
    width: 24px;
    height: 26px;
    margin-right: 11px;
  }
}

.versions__title {
  padding-top: 27px;
  display: flex;
  align-items: center;
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 25px;
  // color: #333333;
  color: #ff6f57;

  &.fuke {
    padding-top: 52px;
  }

  .icon {
    margin-left: 6px;
  }

  &.active {
  }
}
</style>
